import { ApiError } from "../Combined";
import ResultValue from "../Simple/ResultValue";

export default function PTPAddOnEditResults(props) {
    if (props.result && props.result['PTPAddOn.Error']) {
        return (
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header">
                            PTP/AddOn Edits {(props.serviceMode && (`- ${props.serviceMode}`)) || null}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <ApiError error={props.result['PTPAddOn.Error']} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (props.result && props.result['PTPAddOn.PTPAddOnResult'] && props.result['PTPAddOn.PTPAddOnResult'].lines) {
        return null;
    }

    return null;
}